var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent, Fragment } from "react";
import { Route, Redirect } from "react-router";
import { IndexRedirect, NestedRoute, PartialRoute } from "@irati/utils/history/routing";
import AppContainer from "@irati/ui/src/AppContainer";
import authentication from "@irati/auth";
import { greys } from "@irati/ui/src/global/colors";
import { HasPermissionTo } from "@irati/utils/permissions";
import ReportingV2 from "./reportingV2";
import ReportingV3 from "./reportingV3";
import Help from "../containers/Help/Help";
import UserGroups from "../containers/Users/UserGroups";
import UserGroupsUserList from "../containers/Users/UserGroups/UserGroupUserList";
import Dashboard from "../containers/Dashboard";
import AdminSettings from "./adminSettings";
import UserSettings from "./userSettings";
import TeamSettings from "./teamSettings";
import { ADMIN_HOME } from "./routeConfig";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var path = this.props.path;
        var admin = authentication.apps("admin");
        var people = admin.people, teams = admin.teams, tenant = admin.tenant, reportingV3 = admin.reportingV3;
        var indexRoute = ADMIN_HOME;
        return (React.createElement(Route, { path: path, render: function () { return (React.createElement(AppContainer, { addContentMarginTop: true, disableMobile: true, mainBackground: greys.white },
                React.createElement(HasPermissionTo, { permissions: "admin" },
                    React.createElement(NestedRoute, { component: function () { return React.createElement(Fragment, null); }, match: path, path: "/" }),
                    React.createElement(IndexRedirect, { match: { url: path }, to: indexRoute }),
                    React.createElement(NestedRoute, { component: Dashboard, useGrid: false, match: path, path: indexRoute, title: "Admin Dashboard" }),
                    people && React.createElement(NestedRoute, { component: UserSettings, match: path, path: "/people", title: "Manage Users" }),
                    teams && React.createElement(NestedRoute, { component: TeamSettings, match: path, path: "/teams", title: "Teams" }),
                    tenant && React.createElement(NestedRoute, { component: AdminSettings, match: path, path: "/settings", title: "Settings" }),
                    reportingV3 && React.createElement(PartialRoute, { match: path, path: "/reporting-v3", component: ReportingV3, title: "Admin Reporting V3" }),
                    React.createElement(NestedRoute, { component: UserGroups, match: path, exact: true, path: "/products", title: "Products" }),
                    React.createElement(NestedRoute, { component: UserGroupsUserList, match: path, path: "/products/:teamId", title: "Products" }),
                    React.createElement(PartialRoute, { match: path, path: "/reporting-v2", component: ReportingV2, title: "Admin Reporting V2" }),
                    React.createElement(PartialRoute, { match: path, path: "/reporting", component: function () { return React.createElement(Redirect, { to: "/admin/reporting-v2" }); } }),
                    React.createElement(NestedRoute, { component: Help, match: path, path: "/help", title: "Help" })))); } }));
    };
    return default_1;
}(PureComponent));
export default default_1;
